<template>
  <div class="modal-container">
    <div class="confirm-modal d-flex" ref="confirm-modal">
      <div class="division-main-section">
        <div class="modal-title">{{ text }}</div>
        <div class="d-flex justify-content-center gap-3">
          <button class="btn secondary-btn" @click="handleCancel">
            No
          </button>
          <button class="btn secondary-btn" @click="handleConfirm">
            Sí, Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorMessage from "./errorMessage.vue";
import numbersInput from "./numbersInput.vue";
export default {
  name: "confirm-modal",
  props: {
    text: String,
  },
  components: {
    ErrorMessage,
    numbersInput,
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$emit("confirm");
    },
    submitOnEnter(event) {
      if (event.keyCode === 13) {
        if (event.target.value) {
          this.size = parseInt(event.target.value);
        } else {
          this.size = 0;
        }
        this.handleConfirm();
      }
    },
  },
};
</script>
<style scoped>
h2 {
  text-align: center;
  margin: 0px 40px;
}

.modal-section-title {
  display: flex;
  justify-content: center;
  text-align: center;
  /* font-size: 2.7rem; */
  font-size: 1.8rem;
}

.division-main-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 60%;
}

.btn {
  width: 15rem;
  height: 2.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* make unique later */
  font-size: 1rem;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
}


.btn:hover {
  background-color: #cec600;
  background-color: transparent;
  color: #14bf98;
  color: #d6a02d;
  text-decoration: none;
  border: 0.125rem solid #d6a02d;
}
/* 
.confirm-btn {
  width: 20rem;
  height: 3.3rem;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
}

.cancel-btn {
  font-size: 1.5rem;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
} */

.cancel-btn:hover {
  background-color: var(--rose);
  background-color: transparent;
  color: var(--rose);
  text-decoration: none;
  border: 0.125rem solid var(--rose);
}

.modal-title {
  /* font-size: 2.7rem; */
  font-size: 1.8rem;
  text-align: center;
}

.confirm-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 55rem;
  width: 85%;
  height: 23rem;
  background-color: white;
  z-index: 1;
  border-radius: var(--main-border-radius);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  z-index: 2;
}

.modal-container {
  width: 100%;
  height: 100%;
  background-color: #d9d9d9db;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
}

@media screen and (max-width: 700px) {
  .modal-title {
    font-size: 1.2rem;
    width: 70%;
  }

  .confirm-btn,
  .cancel-btn {
    width: 80%;
    /* display: inline-block; */
    padding: 1.375rem 2.125rem 1.375rem 2.125rem;
    border-radius: 0.75rem;
    font: 700 1.25rem/0 "Roboto", sans-serif;
  }

  .secondary-btn {
    width: 70%;
    /* display: inline-block; */
    /* padding: 1.375rem 2.125rem 1.375rem 2.125rem; */
    border-radius: 0.75rem;
    font: 500 1.00rem "Roboto", sans-serif;
  }
}
</style>
